var _path, _path2, _path3, _path4;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
import { forwardRef } from "react";
const SvgMicrosoft = (_ref, ref) => {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M9.55288 9.55288H1V1H9.55288V9.55288Z",
    fill: "#F1511B"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M18.9972 9.55288H10.4436V1H18.9965V9.55288H18.9972Z",
    fill: "#80CC28"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M9.55288 19.0001H1V10.4473H9.55288V19.0001Z",
    fill: "#00ADEF"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M18.9972 19.0001H10.4436V10.4473H18.9965V19.0001H18.9972Z",
    fill: "#FBBC09"
  })));
};
const ForwardRef = /*#__PURE__*/forwardRef(SvgMicrosoft);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/Microsoft.1272dd2bc6e554f0203fceed5281b1aa.svg";